import React from 'react';
import { Link } from 'react-router-dom';
import './Project.css';
import Template from './template/Template.js';
import Python from '../../media/Python.jpg';
import JS from '../../media/js.png';
import Node from '../../media/node.jpeg';
import reactjs from '../../media/React.png';
import reactNativejs from '../../media/React-native.png';
import css from '../../media/css.png';

export default function Project(props) {
    const Css= {
        "--background":`${props.isValue ? props.mode : 'red'}`
    }
    return (
        <>
            <div className="bodyCon projectCon">
                <div className="bodyComponent projectComponent">
                    <div className="aboutHeading projectHeading" style={Css}>
                        <h1>Projects</h1>
                        <div className="container">
                            <div className="projects">
                                <Link to='/project/python'>
                                    <Template img={Python} />
                                </Link>
                                <Link to='/project/js'>
                                    <Template img={JS} />
                                </Link>
                                <Link to='/project/nodejs'>
                                    <Template img={Node} />
                                </Link>

                                <Link to='/project/reactjs'>
                                    <Template img={reactjs} />
                                </Link>
                                <Link to='/project/react-native'>
                                    <Template img={reactNativejs} />
                                </Link>
                                <Link to='/project/css'>
                                    <Template img={css} />
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
